module.exports = __webpack_public_path__ + "static/media/logo@2x.60cb42bf.png";